import React, { useContext, useState, useEffect } from 'react';
import Header from './header';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import LockIcon from '@mui/icons-material/Lock';
import {
    Navigate,
    Link,
    NavLink,
    useNavigate,
    useParams
} from "react-router-dom";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import axios from 'axios';
import CircularProgress from '@mui/material/CircularProgress';
import { AppContext } from '../context';
import { holdUser } from "../features/userdataSlice";
import PageNotFound from './PageNotFound';

function Resetpassword() {
    const { storage } = useContext(AppContext);
    const { id } = useParams();
    const [showOrder, setShowOrder] = useState(false);
    const [userData, setuserData] = useState('');
    const dispatch = useDispatch();
    const [user, setUser] = useState({ parent_name: '', parent_email: '', create_pass: '', confirm_pass: '', old_pass: '' });
    const [successMsg, setSuccessMsg] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [loader, setLoader] = useState(false);
    const [password, setPassword] = useState(true);

    const { dispatchStorageEvent } = useContext(AppContext);
    const [erroruserid, setErrorUserid] = useState(false);
    const [errorpassword, setErrorPassword] = useState(false);
    const [errorcontact, setErrorcontact] = useState(false);
    const [errorcreatepassword, setErrorCreatePassword] = useState(false);
    const [errorconfirmpassword, setErrorConfirmPassword] = useState(false);
    const [erroroldpassword, setErrorOldPassword] = useState(false);
    const [loginval, setloginval] = useState(0);
    const [loading, setLoading] = useState(false);
    const [tokenReady, setTokenReady] = useState(false);
    const [isTokenValid, setIsTokenValid] = useState(false);
    const [isTokenExpired, setIsTokenExpired] = useState(false);
    const [userDetails, setUserDetails] = useState(null);
    const Axios = axios.create({
        baseURL: storage[0].backEndUrl
        // baseURL: process.env.REACT_APP_ENV_URL
    });
    let navigate = useNavigate();

    const [visible, setVisible] = useState(false);
    const [openLog, setOpenLog] = React.useState(false);
    const [passwordparent, setPasswordparent] = useState(true);
    const [passwordoldparent, setPasswordparentold] = useState(true);
    // password section code start
    const [openEye, setOpenEye] = React.useState(false);
    const handleClickOpenEye = () => {
        setPasswordparent(false);
        setOpenEye(true);

    }
    const handleClickCloseEye = () => {
        setPasswordparent(true);
        setOpenEye(false);

    }

    const [openLogcon, setOpenLogcon] = React.useState(false);
    const [passwordparentcon, setPasswordparentcon] = useState(true);
    // password section code start
    const [openEyecon, setOpenEyecon] = React.useState(false);
    const handleClickOpenEyecon = () => {
        setPasswordparentcon(false);
        setOpenEyecon(true);

    }
    const handleClickCloseEyecon = () => {
        setPasswordparentcon(true);
        setOpenEyecon(false);

    }

    const [openEyeold, setOpenEyeold] = React.useState(false);
    const handleClickOpenEyeold = () => {
        setPasswordparentold(false);
        setOpenEyeold(true);

    }
    const handleClickCloseEyeold = () => {
        setPasswordparentold(true);
        setOpenEyeold(false);

    }
    const logout = (e) => {
        localStorage.removeItem("username");
        localStorage.removeItem("userdata");

        dispatch(holdUser({}));
        navigate(`/`);

    }

    React.useEffect(() => {

        if (document.body.classList.contains('body_bg')) {
            document.body.classList.remove('body');

        }
        document.body.classList.add('body_bg');
        var userid = window.localStorage.getItem('username');

        //check token is valid or not
        Axios.post(`/forgot-passowrd/check-token`, { token: id })
            .then(res => {
                if (res.data.status) {
                    if(res.data.data.expired){
                        setIsTokenExpired(true);
                        setUserDetails(res.data.data.user);
                    }else{
                        setIsTokenExpired(false);
                    }
                } else {
                    setIsTokenValid(true);
                }
                setTokenReady(true);
            }).catch((error) => {

            })

    }, []);

    const handleKeypress = e => {
        //it triggers by pressing the enter key
        if (e.which === 13) {
            handleSubmit();
            e.preventDefault();

        }
    };
    const changeUserData = (e) => {
        setErrorUserid(false);
        setErrorPassword(false);
        setErrorcontact(false);
        setErrorCreatePassword(false);
        setErrorConfirmPassword(false);
        setErrorOldPassword(false);
        var user_temp = { ...user };
        if (e.target.name == 'parent_name') user_temp.parent_name = e.target.value;
        if (e.target.name == 'parent_email') user_temp.parent_email = e.target.value;
        if (e.target.name == 'create_pass') user_temp.create_pass = e.target.value;
        if (e.target.name == 'confirm_pass') user_temp.confirm_pass = e.target.value;
        if (e.target.name == 'old_pass') user_temp.old_pass = e.target.value;
        setUser(user_temp);
    }
    const handleSubmit = (event) => {

        setErrorMsg('');
        setSuccessMsg('');
        setErrorUserid(false);
        setErrorPassword(false);
        setErrorcontact(false);
        setErrorCreatePassword(false);
        setErrorConfirmPassword(false);
        setErrorOldPassword(false);

        // if (user.old_pass == '') { 

        //     setErrorOldPassword(true); return false; }

        if (user.create_pass == '') { setErrorCreatePassword(true); return false; }
        if (user.confirm_pass == '') { setErrorConfirmPassword(true); return false; }
        // if (user.old_pass == user.create_pass) { setErrorMsg('New and Old Password must not be Same'); return false; }

        if (user.confirm_pass != user.create_pass) { setErrorMsg('New and Confirm Password must be Same'); return false; }
        setLoader(true);
        Axios.post(`/update_password`, { token: id, old_password: user.old_pass, password: user.create_pass, confirm_password: (user.confirm_pass) })
            .then(res => {
                console.log(res.data);

                if (res.data.status == true) {

                    dispatchStorageEvent(storage);
                    setSuccessMsg('You are now being redirected to the login page');

                    setLoader(false);

                    setTimeout(function () {
                        setloginval(2);
                    }, 3000);



                }
                else {
                    setloginval(0);
                    setErrorMsg(res.data.data);
                    setLoader(false);
                }
            });
    }
    if (loginval == 2) {
        return <Navigate to='/' />;
    }

    const handleForgotPass = (event) => {
        event.preventDefault();
        localStorage.setItem("userdata", JSON.stringify(userDetails));
        localStorage.setItem('username', userDetails.stuid);
        navigate(`/password`);
    }

    return (
        <>
            {
                tokenReady && isTokenValid ?
                <PageNotFound />
                :
                <>
                    <Header />

                    <div className={`regis-main-sec ${!tokenReady || (tokenReady && isTokenExpired) ? 'loader-new' : ''}`}>
                        {
                            !tokenReady ?
                                <CircularProgress />
                                :
                                <>
                                    {
                                        isTokenExpired ?
                                            <div className="error-msg error-rst" >
                                                <p className="error-msg">Your Password Reset Link has expired.</p>
                                                <p className="error-msg error-reset pass-expired">
                                                    If you need to reset your password please click here <a href='#' onClick={handleForgotPass}>Forgot Password</a> or go to <Link to="/">Login</Link>
                                                </p>
                                            </div>
                                            :
                                            <div className='container'>
                                                <div className='row'>
                                                    <div className='col-md-12'>
                                                        <div className='regis-head pass-head'>
                                                            <h2>RESET PASSWORD </h2>
                                                            {/* <p>You only register once</p>*/}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='regis-form-sec reset-pass'>
                                                    <div className='row'>
                                                        <div className='col-md-12'>

                                                            <div className='login-sec-page modl-login regis-top pass-wrd-sec'>
                                                                {/*  <div className='  login-secs regis-email login-secssss'>
                                                                                <Box
                                                                                component="form"
                                                                                sx={{
                                                                                    '& > :not(style)': { m: 1, width: '100%', margin: '0 auto' },
                                                                                }}
                                                                                noValidate
                                                                                autoComplete="off"
                                                                                >

                                                                                <TextField id="standard-basic" label="Old Password" variant="outlined"
                                                                                    type={passwordoldparent ? 'password' : 'text'} 
                                                                                    onKeyPress={handleKeypress}
                                                                    name="old_pass"
                                                                    value={user.old_pass} onChange={changeUserData}

                                                                    error={erroroldpassword}  placeholder=''

                                                                    helperText={` ${erroroldpassword == true ? 'Please enter Old Password!' : ''}`}
                                                                    className="required" />
                                                                                <span className='login-icon-regis login-icon-regis-no'><LockIcon /></span>

                                                                                <div className='psd-sec'>
                                                                                <span className="visible-sec" onClick={handleClickOpenEyeold} style={{display: openEyeold ? "none" : "block" }}><VisibilityOffIcon /></span>
                                                                                <span className="visible-sec" onClick={handleClickCloseEyeold} style={{display: openEyeold ? "block" : "none" }}><VisibilityIcon /></span>
                                                                        </div>
                                                                                </Box>
                                                                            </div>
                                                    */}

                                                                <div className='login-secs  login-secssss'>
                                                                    <Box
                                                                        component="form"
                                                                        sx={{
                                                                            '& > :not(style)': { m: 1, width: '100%', margin: '0 auto' },
                                                                        }}
                                                                        noValidate
                                                                        autoComplete="off"
                                                                    >

                                                                        <TextField id="standard-basic" label="New Password" variant="outlined"
                                                                            type={passwordparent ? 'password' : 'text'}
                                                                            onKeyPress={handleKeypress}
                                                                            name="create_pass"
                                                                            value={user.create_pass} onChange={changeUserData}

                                                                            error={errorcreatepassword} placeholder=''

                                                                            helperText={` ${errorcreatepassword == true ? 'Please enter  New Password!' : ''}`} className="required" />
                                                                        <span className='login-icon-regis login-icon-regis-no'><LockIcon /></span>

                                                                        <div className='psd-sec'>
                                                                            <span className="visible-sec" onClick={handleClickOpenEye} style={{ display: openEye ? "none" : "block" }}><VisibilityOffIcon /></span>
                                                                            <span className="visible-sec" onClick={handleClickCloseEye} style={{ display: openEye ? "block" : "none" }}><VisibilityIcon /></span>
                                                                        </div>
                                                                    </Box>
                                                                </div>


                                                                <div className='login-secs login-secssss'>
                                                                    <Box
                                                                        component="form"
                                                                        sx={{
                                                                            '& > :not(style)': { m: 1, width: '100%', margin: '0 auto' },
                                                                        }}
                                                                        noValidate
                                                                        autoComplete="off"
                                                                    >

                                                                        <TextField id="standard-basic" label="Confirm Password" variant="outlined"
                                                                            type={passwordparentcon ? 'password' : 'text'}
                                                                            onKeyPress={handleKeypress}
                                                                            name="confirm_pass"
                                                                            value={user.confirm_pass} onChange={changeUserData}

                                                                            error={errorconfirmpassword} placeholder=''

                                                                            helperText={` ${errorconfirmpassword == true ? 'Please enter Confirm Password!' : ''}`} className="required" />
                                                                        <span className='login-icon-regis login-icon-regis-no'><LockIcon /></span>
                                                                        <div className='psd-sec'>
                                                                            <span className="visible-sec" onClick={handleClickOpenEyecon} style={{ display: openEyecon ? "none" : "block" }}><VisibilityOffIcon /></span>
                                                                            <span className="visible-sec" onClick={handleClickCloseEyecon} style={{ display: openEyecon ? "block" : "none" }}><VisibilityIcon /></span>
                                                                        </div>
                                                                    </Box>
                                                                </div>

                                                                <div className='login-submit' style={{ textAlign: 'center' }}>

                                                                    <button className='btn btn-login btn-login-sumt btn-reg-submt' onClick={handleSubmit}>SUBMIT
                                                                        {
                                                                            loader != '' ?
                                                                                <CircularProgress style={{ width: "15px", height: "15px", marginLeft: "5px", color: "#ffffff", position: 'absolute', marginTop: '3px' }} />
                                                                                : ''

                                                                        }</button>
                                                                    {
                                                                        loader != '' ? <div className="success-msg success-new-msg">
                                                                            <p className="success-msg">New Password Stored Successfully.</p>

                                                                        </div> :
                                                                            <div className="success-msg success-new-msg">
                                                                                <p className="success-msg" style={{ visibility: 'hidden' }} >Please wait while we fetch your data</p>
                                                                            </div>
                                                                    }

                                                                    {
                                                                        successMsg != '' ? <div className="success-msgfor">
                                                                            <p className="success-msgfor">{successMsg}</p>
                                                                        </div> : ''
                                                                    }


                                                                    {
                                                                        errorMsg != '' ? <div className="error-msg" >
                                                                            <p className="error-msg">{errorMsg}</p>
                                                                        </div> : <div className="error-msg" style={{ visibility: 'hidden' }} >
                                                                            <p className="error-msg">Wrong credentials!</p>
                                                                        </div>
                                                                    }

                                                                </div>

                                                            </div>


                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                    }
                                </>
                        }

                    </div>
                </>
            }
        </>
    )
}

export default Resetpassword;